/// <reference path="../../../typings/references.d.ts" />

module PartnershipsModule {

    class AdminActivityLayoutController {

        constructor() {
        }
    }

    angular
        .module('app')
        .controller('AdminActivityLayoutController', AdminActivityLayoutController)

}